import MItemSection from "./MItemSection.vue";
export default MItemSection;
export type { MItemSectionProps } from "./MItemSection.props";
